import classNames from 'classnames'
import React from 'react'
import Selectable, { SelectableProps } from './Selectable'
import styles from './styles.css'

const SelectableCard: React.SFC<SelectableProps> = ({
  className,
  id,
  value,
  disabled,
  ...props
}) => {
  const classes = classNames(className, {
    [styles.card]: true,
    [styles.selected]: props.checked,
    [styles.cardWithRadius]: !props.overrideRadius
  })

  return (
    <Selectable id={id} className={classes} value={value} disabled={disabled} {...props}>
      {props.children}
    </Selectable>
  )
}

export default SelectableCard

SelectableCard.defaultProps = {
  disabled: false
}
